<div *ngIf="busy">
   Please wait...
</div>

<div *ngIf="!busy" style="margin: 15px 0;">

   Ladder:
   <select [(ngModel)]="ladderId" (ngModelChange)="ladderChanged($event)">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.name}} ({{l.ladderId}})</option>
   </select>
   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <button [routerLink]="['/admin','pairing']" [queryParams]="{ladderid: ladderId}">Do Pairings</button>
   <br /><br />

   <div *ngIf="msg" style="background: greenyellow;">
      {{msg}}
   </div>
   <div *ngIf="players.length > 0" style="margin-bottom: 10px;">
      <strong>{{selectedCount}}</strong> selected
      &nbsp;&nbsp;
      <button [disabled]="selectedCount === 0" (click)="bulkLevelDialog()">Move Selected to Level</button>
      &nbsp;
      <button [disabled]="selectedCount === 0" (click)="bulkLadderDialog()">Move Selected to Ladder</button>
   </div>
   <table class="table table-bordered table-striped" *ngIf="players.length > 0 ">
      <thead class="thead-dark">
         <tr>
            <th width="1%" (click)="toggleSelectAll()" style="cursor: pointer;" title="Select all">
               <input type="checkbox" [checked]="allSelected()" style="pointer-events: none;" />
            </th>
            <th>Name</th>
            <th>Level</th>
            <th>Paid</th>
            <th>Drop</th>
            <th>Change Level</th>
            <th>Change Ladder</th>
            <th>Phone</th>
         </tr>
      </thead>
      <tbody class="table-striped">
         <tr *ngFor="let p of players">
            <td (click)="toggleSelected(p.id, p.levelId)" style="cursor: pointer;">
               <input type="checkbox" [checked]="isSelected(p.id, p.levelId)" style="pointer-events: none;" />
            </td>
            <td>
               <a href="#" (click)="showHistory($event, p.id)">{{p.getFullName()}}</a>
               <sup>{{p.rank}}</sup>
            </td>
            <td>{{p.levelId}}</td>
            <td nowrap>
               <button *ngIf="!p.paid && p.levelId > 1" (click)="markPaid($event, p.id, p.levelId)">Mark Paid</button>
               <a *ngIf="paidIds.includes(p.id)" href="#" style="cursor: pointer;" (click)="markUnPaid($event, p.id, p.levelId)">Mark Un-Paid</a>
            </td>
            <td nowrap>
               <button *ngIf="p.levelId != 1" (click)="dropLadder($event, p.id, p.levelId)">Drop Ladder</button>
            </td>
            <!--<a *ngIf="paidIds.includes(p.id)" href="#" style="cursor: pointer;" (click)="markUnPaid($event, p.id, p.levelId)">Mark Un-Paid</a>-->
            <td nowrap>
               <button (click)="levelDialog($event, p.id, p.levelId)">Change Level</button>
            </td>
            <td nowrap>
               <button (click)="ladderDialog($event, p.id, p.levelId)">Change Ladder</button>
            </td>
            <td nowrap>
               {{p.phoneNumber}}
            </td>
         </tr>
      </tbody>
   </table>



</div>